export default "__VITE_PUBLIC_ASSET__e2ca3ca9__"